import { render, staticRenderFns } from "./subscription-price.vue?vue&type=template&id=46362f9b&scoped=true"
import script from "./subscription-price.vue?vue&type=script&lang=js"
export * from "./subscription-price.vue?vue&type=script&lang=js"
import style0 from "./subscription-price.vue?vue&type=style&index=0&id=46362f9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46362f9b",
  null
  
)

export default component.exports